import {Routes} from '@src/Constant/routes';
import {RouteComponentProps} from '@reach/router';
import React from 'react';
import {KeyRouteMap, RouteConfig} from '../types';

// Composants liés à l'apprentissage
const LearnHomePage = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/LearnHomePage/LearnHomePage'
    ),
);
const SingleCourse = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/JobBoardsScreen/SingleCourse/SingleCourse'
    ),
);
const UnitScreen = React.lazy(
  () => import('@src/App/components/pages/LearnHomePage/UnitScreen/UnitScreen'),
);
const ExamScreen = React.lazy(
  () => import('@src/App/components/pages/LearnHomePage/ExamScreen/ExamScreen'),
);
const LinkedJob = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/JobBoardsScreen/LinkedJob/LinkedJob'
    ),
);
const ExamResultPage = React.lazy(
  () =>
    import('@src/App/components/pages/LearnHomePage/ExamScreen/ExamResultPage'),
);
const PartnersPage = React.lazy(
  () =>
    import('@src/App/components/pages/LearnHomePage/PartnersPage/PartnersPage'),
);
const PartnerSingle = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/PartnersPage/PartnerSingle/PartnerSingle'
    ),
);
const HomeQuizPage = React.lazy(
  () => import('@src/App/components/pages/QuizPage/HomeQuizPage/HomeQuizPage'),
);
const QuizQuestionPage = React.lazy(
  () =>
    import(
      '@src/App/components/pages/QuizPage/QuizQuestionPage/QuizQuestionPage'
    ),
);
const QuizPersonalityPage = React.lazy(
  () =>
    import(
      '@src/App/components/pages/QuizPage/QuizPersonalityPage/QuizPersonalityPage'
    ),
);
const QuizMethodologyPage = React.lazy(
  () =>
    import(
      '@src/App/components/pages/QuizPage/QuizMethodologyPage/QuizMethodologyPage'
    ),
);
const QuizResultPage = React.lazy(
  () =>
    import('@src/App/components/pages/QuizPage/QuizResultPage/QuizResultPage'),
);
const PersonalityPage = React.lazy(
  () =>
    import(
      '@src/App/components/pages/QuizPage/PersonalityPage/PersonalityPage'
    ),
);
const SingleJob = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/JobBoardsScreen/SingleJob/SingleJob'
    ),
);
const JobHubScreen = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/JobBoardsScreen/JobHubScreen'
    ),
);
const JobVacancyScreen = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/JobBoardsScreen/JobVacancyScreen'
    ),
);
const JobBoardsScreen = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/JobBoardsScreen/JobBoardsScreen'
    ),
);
const JobBoardEntrepreneurial = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/JobBoardsScreen/JobBoardEntrepreneurial'
    ),
);
const OpportunitiesScreen = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/JobBoardsScreen/OpportunitiesScreen'
    ),
);
const SingleOpportunity = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/JobBoardsScreen/SingleOpportunity/SingleOpportunity'
    ),
);
const CourseCategoryPage = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/CourseCategoryPage/CourseCategoryPage'
    ),
);
const QuizzSurveyCollectionScreen = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/QuizzSurvey/QuizzSurveyCollectionScreen'
    ),
);
const QuizzSurveyScreen = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/QuizzSurvey/QuizzSurveyScreen'
    ),
);
const QuizzSurveyCategoryScreen = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/QuizzSurvey/QuizzSurveyCategoryScreen'
    ),
);
const PlayerQuizSurveyScreen = React.lazy(
  () =>
    import(
      '@src/App/components/pages/LearnHomePage/QuizzSurvey/PlayerQuizSurveyScreen'
    ),
);
const TutorialScreen = React.lazy(
  () => import('@src/App/components/pages/TutorialScreen/TutorialScreen'),
);

export const learnRoutes: KeyRouteMap = {
  [Routes.HOME_LEARN]: {component: LearnHomePage},
  [Routes.COURSE_SINGLE]: {
    component: SingleCourse,
    parent: Routes.HOME_LEARN,
  },
  [Routes.COURSE_UNIT]: {
    component: UnitScreen,
    parent: Routes.HOME_LEARN,
  },
  [Routes.EXAM]: {
    component: ExamScreen,
    parent: Routes.HOME_LEARN,
  },
  [Routes.LINKED_JOB]: {
    component: LinkedJob,
    parent: Routes.HOME_LEARN,
  },
  [Routes.EXAM_RESULT_OVERVIEW]: {
    component: ExamResultPage,
    parent: Routes.HOME_LEARN,
  },
  [Routes.PARTNERS_LANDING]: {
    component: PartnersPage,
    parent: Routes.HOME_LEARN,
  },
  [Routes.PARTNER_SINGLE]: {
    component: PartnerSingle,
    parent: Routes.HOME_LEARN,
  },
  [Routes.HOME_QUIZ]: {
    component: HomeQuizPage,
    parent: Routes.HOME_LEARN,
  },
  [Routes.QUIZ_QUESTION]: {
    component: QuizQuestionPage,
    parent: Routes.HOME_LEARN,
  },
  [Routes.QUIZ_PERSONALITY]: {
    component: QuizPersonalityPage,
    parent: Routes.HOME_LEARN,
  },
  [Routes.QUIZ_METHODOLOGY]: {
    component: QuizMethodologyPage,
    parent: Routes.HOME_LEARN,
  },
  [Routes.QUIZ_RESULT]: {
    component: QuizResultPage,
    parent: Routes.HOME_LEARN,
  },
  [Routes.PERSONALITY]: {
    component: PersonalityPage,
    parent: Routes.HOME_LEARN,
  },
  [Routes.SINGLE_JOB]: {
    component: SingleJob,
    parent: Routes.HOME_LEARN,
  },
  [Routes.JOB_HUB]: {
    component: JobHubScreen,
    parent: Routes.HOME_LEARN,
  },
  [Routes.JOB_VACANCIES]: {
    component: JobVacancyScreen,
    parent: Routes.HOME_LEARN,
  },
  [Routes.JOB_BOARD_PAGE]: {
    component: JobBoardsScreen,
    parent: Routes.HOME_LEARN,
  },
  [Routes.ENTREPRENEURIAL_HUB]: {
    component: JobBoardEntrepreneurial,
    parent: Routes.HOME_LEARN,
  },
  [Routes.OPPORTUNITY_CENTER]: {
    component: OpportunitiesScreen,
    parent: Routes.HOME_LEARN,
  },
  [Routes.OPPORTUNITY_SINGLE]: {
    component: SingleOpportunity,
    parent: Routes.HOME_LEARN,
  },
  [Routes.COURSE_CATEGORY]: {
    component: CourseCategoryPage,
    parent: Routes.HOME_LEARN,
  },
  [Routes.COURSE_CATEGORY_HOME]: {
    component: CourseCategoryPage,
    parent: Routes.HOME_LEARN,
  },
  [Routes.QUIZZ_SURVEY_COLLECTION]: {
    component: QuizzSurveyCollectionScreen,
  },
  [Routes.QUIZZ_SURVEY]: {component: QuizzSurveyScreen},
  [Routes.QUIZZ_SURVEY_CATEGORY]: {component: QuizzSurveyCategoryScreen},
  [Routes.PLAYER_QUIZ_SURVEY]: {component: PlayerQuizSurveyScreen},
  [Routes.TUTORIAL]: {component: TutorialScreen},
};
